import {
  Phone,
  Mail,
  MapPin,
  Facebook,
  Linkedin,
  Instagram,
  Youtube,
  ArrowRight,
} from "lucide-react";
import { FaXTwitter } from "react-icons/fa6";
import { FaPinterest } from "react-icons/fa";
import { Link } from "react-router-dom";

function LocationFooter({ removeTopGap = false }) {
  const lifeLinks = [
    { label: "Life Insurance", to: "/life-insurance" },
    { label: "Term life insurance", to: "/term-life-insurance" },
    { label: "Permanent Life Insurance", to: "/permanent-life-insurance" },
    { label: "Whole Life Insurance", to: "/whole-life-insurance" },
    { label: "Mortgage Insurance", to: "/mortgage-insurance" },
    { label: "Universal life insurance", to: "/universal-life-insurance" },
    { label: "No Medical insurance", to: "/no-medical-insurance" },
    { label: "Children insurance", to: "/children-insurance" },
    { label: "Health Insurance", to: "/health-insurance" },
  ];

  const investmentLinks = [
    { label: "First Home Savings Account (FHSA)", to: "/first-home-savings-account" },
    { label: "Tax-Free Savings Account (TFSA)", to: "/tax-free-savings-account" },
    {
      label: "Registered Education Savings Plan (RESP)",
      to: "/registered-education-savings-plan",
    },
    {
      label: "Registered Retirement Savings Plan (RRSP)",
      to: "/registered-retirement-savings-plan",
    },
    {
      label: "Registered Disability Savings Plan (RDSP)",
      to: "/registered-disability-savings-plan",
    },
  ];

  const travelLinks = [
    {
      label: "Visitor to Canada Insurance",
      to: "/visitor-to-canada-insurance",
    },
    { label: "Super Visa Insurance", to: "/super-visa-insurance" },
    { label: "Newcomers Insurance", to: "/newcomers-insurance" },
    {
      label: "International Student Insurance",
      to: "/international-student-insurance",
    },
    { label: "Travel Insurance", to: "/travel-insurance" },
  ];

  const livingLinks = [
    { label: "Critical Illness Insurance", to: "/critical-illness-insurance" },
    { label: "Disability Insurance", to: "/disability-insurance" },
  ];

  const container = "max-w-[1380px] mx-auto px-4 sm:px-6";
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className={`${
        removeTopGap ? "mt-0" : "mt-[50px]"
      } bg-gradient-to-r from-sky-600 to-[#153955] text-white pt-6 md:pt-8`}
      aria-label="Footer"
    >
      {/* DESKTOP */}
      <div
        className={`${container} hidden md:grid grid-cols-2 lg:grid-cols-4 gap-7 md:gap-8 pb-6`}
      >
        {/* Column 1: About + Our Services + Contact */}
        <div>
          <h3 className="font-bold mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">
            <Link to="/about-us" className="hover:text-sky-300 inline-block">
              ABOUT US
            </Link>
          </h3>

          <ul className="space-y-1 md:space-y-1.5 text-sm">
            <li>
              <Link
                to="/everything-we-sell"
                className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded"
              >
                <ArrowRight size={15} /> Our Services
              </Link>
            </li>
          </ul>

          <h3 className="font-bold mt-4 md:mt-5 mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">
            CONTACT
          </h3>

          <ul className="space-y-2.5 text-sm">
            <li className="flex items-center gap-2">
              <Phone size={16} className="text-sky-300 shrink-0" />
              <a
                href="tel:+18444400128"
                className="hover:text-sky-300 focus:outline-none focus:ring-2 focus:ring-sky-300 rounded break-all"
                aria-label="Call +1 (844) 440-0128"
              >
                +1 (844) 440-0128
              </a>
            </li>

            <li className="flex items-start gap-2">
              <MapPin size={16} className="text-sky-300 mt-1 shrink-0" />
              <a
                href="https://www.google.com/maps?q=9300+Goreway+Drive,+%23106,+Brampton,+ON+L6P+4N1"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-sky-300 focus:outline-none focus:ring-2 focus:ring-sky-300 rounded leading-snug"
                aria-label="Open location on Google Maps"
              >
                9300 Goreway Drive, #106
                <br />
                Brampton, ON L6P 4N1
              </a>
            </li>

            <li className="flex items-center gap-2">
              <Mail size={16} className="text-sky-300 shrink-0" />
              <a
                href="mailto:info@einsured.ca"
                className="hover:text-sky-300 focus:outline-none focus:ring-2 focus:ring-sky-300 rounded break-all"
                aria-label="Email info@einsured.ca"
              >
                info@einsured.ca
              </a>
            </li>
          </ul>
                    {/* <h3 className="font-bold mt-4 md:mt-5 mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">
            LOCATIONS
          </h3> */}

          {/* <ul className="space-y-1 md:space-y-1.5 text-sm">
            <li>
              <Link
                to="/life-insurance-toronto"
                className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded"
              >
                <ArrowRight size={15} /> Insurance Services in Toronto
              </Link>
            </li>

            <li>
              <Link
                to="/life-insurance-brampton"
                className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded"
              >
                <ArrowRight size={15} /> Insurance Services in Brampton
              </Link>
            </li>
          </ul> */}
        </div>

        {/* Column 2: Life Services */}
        <div>
          <h3 className="font-bold mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">
            LIFE SERVICES
          </h3>
          <ul className="space-y-1 md:space-y-1.5 text-sm">
            {lifeLinks.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded"
                >
                  <ArrowRight size={15} /> {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 3: Investments + Travel Insurance */}
        <div>
          <h3 className="font-bold mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">
            INVESTMENTS
          </h3>
          <ul className="space-y-1 md:space-y-1.5 text-sm">
            {investmentLinks.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded"
                >
                  <ArrowRight size={15} /> {item.label}
                </Link>
              </li>
            ))}
          </ul>

          <h3 className="font-bold mt-4 md:mt-5 mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">
            TRAVEL INSURANCE
          </h3>
          <ul className="space-y-1 md:space-y-1.5 text-sm">
            {travelLinks.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded"
                >
                  <ArrowRight size={15} /> {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 4: Living Benefits + Resources + Our Team */}
        <div>
          <h3 className="font-bold mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">
            LIVING BENEFITS
          </h3>
          <ul className="space-y-1 md:space-y-1.5 text-sm">
            {livingLinks.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded"
                >
                  <ArrowRight size={15} /> {item.label}
                </Link>
              </li>
            ))}
          </ul>

          <h3 className="font-bold mt-4 md:mt-5 mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">
            RESOURCES
          </h3>
          <ul className="space-y-1 md:space-y-1.5 text-sm">
            <li>
              <Link
                to="/case-studies"
                className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded"
              >
                <ArrowRight size={15} /> Case Studies
              </Link>
            </li>
          </ul>

          <h3 className="font-bold mt-4 md:mt-5 mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">
            OUR TEAM
          </h3>
          <ul className="space-y-1 md:space-y-1.5 text-sm">
            <li>
              <Link
                to="/our-team"
                className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded"
              >
                <ArrowRight size={15} /> Our Team
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* MOBILE VERSION */}
      <div className={`${container} md:hidden pb-6 space-y-3`}>
        {/* 1) About + Contact */}
        <details className="group bg-white/5 rounded-lg px-4 py-3">
          <summary className="flex justify-between items-center cursor-pointer list-none">
            <span className="font-semibold text-xs tracking-wider">
              ABOUT & CONTACT
            </span>
            <span className="text-xs text-white/70">
              <span className="group-open:hidden">Tap to expand</span>
              <span className="hidden group-open:inline">Tap to collapse</span>
            </span>
          </summary>

          <div className="mt-3 space-y-4 text-sm">
            <div>
              <p className="font-semibold mb-1 text-[13px] tracking-wider">
                <Link to="/about-us" className="hover:text-sky-300">
                  ABOUT US
                </Link>
              </p>
              <ul className="space-y-1.5">
                <li>
                  <Link
                    to="/everything-we-sell"
                    className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"
                  >
                    <ArrowRight size={15} /> Our Services
                  </Link>
                </li>
              </ul>
            </div>

            <div className="pt-3 border-t border-white/10">
              <p className="font-semibold mb-2 text-[13px] tracking-wider">
                CONTACT
              </p>

              <ul className="space-y-3">
                <li className="flex items-center gap-2">
                  <Phone size={16} className="text-sky-300 shrink-0" />
                  <a
                    href="tel:+18444400128"
                    className="hover:text-sky-300 focus:outline-none focus:ring-2 focus:ring-sky-300 rounded break-all"
                    aria-label="Call +1 (844) 440-0128"
                  >
                    +1 (844) 440-0128
                  </a>
                </li>

                <li className="flex items-start gap-2">
                  <MapPin size={16} className="text-sky-300 mt-1 shrink-0" />
                  <a
                    href="https://www.google.com/maps?q=9300+Goreway+Drive,+%23106,+Brampton,+ON+L6P+4N1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-sky-300 focus:outline-none focus:ring-2 focus:ring-sky-300 rounded leading-snug"
                    aria-label="Open location on Google Maps"
                  >
                    9300 Goreway Drive, #106
                    <br />
                    Brampton, ON L6P 4N1
                  </a>
                </li>

                <li className="flex items-center gap-2">
                  <Mail size={16} className="text-sky-300 shrink-0" />
                  <a
                    href="mailto:info@einsured.ca"
                    className="hover:text-sky-300 focus:outline-none focus:ring-2 focus:ring-sky-300 rounded break-all"
                    aria-label="Email info@einsured.ca"
                  >
                    info@einsured.ca
                  </a>
                </li>
                           </ul>
            </div>

            {/* <div className="pt-3 border-t border-white/10">
              <p className="font-semibold mb-1 text-[13px] tracking-wider">
                LOCATIONS
              </p>

              <ul className="space-y-1.5">
                <li>
                  <Link
                    to="/life-insurance-toronto"
                    className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"
                  >
                    <ArrowRight size={15} /> Insurance Services in Toronto
                  </Link>
                </li>

                <li>
                  <Link
                    to="/life-insurance-brampton"
                    className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"
                  >
                    <ArrowRight size={15} /> Insurance Services in Brampton
                  </Link>
                </li>
              </ul>
            </div> */}
          </div>
        </details>
        

        {/* 2) Life Services */}
        <details className="group bg-white/5 rounded-lg px-4 py-3">
          <summary className="flex justify-between items-center cursor-pointer list-none">
            <span className="font-semibold text-xs tracking-wider">
              LIFE SERVICES
            </span>
            <span className="text-xs text-white/70">
              <span className="group-open:hidden">Tap to expand</span>
              <span className="hidden group-open:inline">Tap to collapse</span>
            </span>
          </summary>
          <ul className="mt-3 space-y-1.5 text-sm">
            {lifeLinks.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"
                >
                  <ArrowRight size={15} /> {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </details>

        {/* 3) Investments + Travel */}
        <details className="group bg-white/5 rounded-lg px-4 py-3">
          <summary className="flex justify-between items-center cursor-pointer list-none">
            <span className="font-semibold text-xs tracking-wider">
              INVESTMENTS & TRAVEL
            </span>
            <span className="text-xs text-white/70">
              <span className="group-open:hidden">Tap to expand</span>
              <span className="hidden group-open:inline">Tap to collapse</span>
            </span>
          </summary>

          <div className="mt-3 space-y-4 text-sm">
            <div>
              <p className="font-semibold mb-1 text-[13px] tracking-wider">
                INVESTMENTS
              </p>
              <ul className="space-y-1.5">
                {investmentLinks.map((item) => (
                  <li key={item.to}>
                    <Link
                      to={item.to}
                      className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"
                    >
                      <ArrowRight size={15} /> {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="pt-3 border-t border-white/10">
              <p className="font-semibold mb-1 text-[13px] tracking-wider">
                TRAVEL INSURANCE
              </p>
              <ul className="space-y-1.5">
                {travelLinks.map((item) => (
                  <li key={item.to}>
                    <Link
                      to={item.to}
                      className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"
                    >
                      <ArrowRight size={15} /> {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </details>

        {/* 4) Living Benefits + Resources + Our Team */}
        <details className="group bg-white/5 rounded-lg px-4 py-3">
          <summary className="flex justify-between items-center cursor-pointer list-none">
            <span className="font-semibold text-xs tracking-wider">
              LIVING + RESOURCES + TEAM
            </span>
            <span className="text-xs text-white/70">
              <span className="group-open:hidden">Tap to expand</span>
              <span className="hidden group-open:inline">Tap to collapse</span>
            </span>
          </summary>

          <div className="mt-3 space-y-4 text-sm">
            <div>
              <p className="font-semibold mb-1 text-[13px] tracking-wider">
                LIVING BENEFITS
              </p>
              <ul className="space-y-1.5">
                {livingLinks.map((item) => (
                  <li key={item.to}>
                    <Link
                      to={item.to}
                      className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"
                    >
                      <ArrowRight size={15} /> {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="pt-3 border-t border-white/10">
              <p className="font-semibold mb-1 text-[13px] tracking-wider">
                RESOURCES
              </p>
              <ul className="space-y-1.5">
                <li>
                  <Link
                    to="/case-studies"
                    className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"
                  >
                    <ArrowRight size={15} /> Case Studies
                  </Link>
                </li>
              </ul>
            </div>

            <div className="pt-3 border-t border-white/10">
              <p className="font-semibold mb-1 text-[13px] tracking-wider">
                OUR TEAM
              </p>
              <Link
                to="/our-team"
                className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"
              >
                <ArrowRight size={15} /> Our Team
              </Link>
            </div>
          </div>
        </details>
      </div>

      {/* Social Icons */}
      <div className="flex flex-wrap justify-center gap-3 sm:gap-4 px-4 pb-4">
        <a
          href="https://www.facebook.com/einsured.ca/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          className="bg-white/10 hover:bg-sky-400 text-white p-2.5 rounded-full transition"
        >
          <Facebook size={18} />
        </a>
        <a
          href="https://www.linkedin.com/company/einsured-ca/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
          className="bg-white/10 hover:bg-sky-400 text-white p-2.5 rounded-full transition"
        >
          <Linkedin size={18} />
        </a>
        <a
          href="https://www.instagram.com/einsured.ca/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          className="bg-white/10 hover:bg-sky-400 text-white p-2.5 rounded-full transition"
        >
          <Instagram size={18} />
        </a>
        <a
          href="https://in.pinterest.com/einsuredca/?eq=einsured&etslf=6832"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Pinterest"
          className="bg-white/10 hover:bg-sky-400 text-white p-2.5 rounded-full transition"
        >
          <FaPinterest size={18} />
        </a>
        <a
          href="mailto:info@einsured.ca"
          aria-label="Email"
          className="bg-white/10 hover:bg-sky-400 text-white p-2.5 rounded-full transition"
        >
          <Mail size={18} />
        </a>
        <a
          href="https://www.youtube.com/@einsured1546"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="YouTube"
          className="bg-white/10 hover:bg-sky-400 text-white p-2.5 rounded-full transition"
        >
          <Youtube size={18} />
        </a>
        <a
          href="https://x.com/EinsuredCa"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Twitter / X"
          className="bg-white/10 hover:bg-sky-400 text-white p-2.5 rounded-full transition"
        >
          <FaXTwitter size={18} />
        </a>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#0a1928] text-center text-xs sm:text-sm py-2 border-t border-white/10 px-4">
        <div
          className={`${container} flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4`}
        >
          <p className="opacity-90">
            Copyright © {currentYear} - All rights reserved | einsured.ca.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
            <Link to="/privacy-policy" className="hover:text-sky-300">
              Privacy Policy
            </Link>

            <span className="opacity-40 hidden sm:inline">|</span>
            <Link to="/terms-and-conditions" className="hover:text-sky-300">
              Terms & Conditions
            </Link>

            <span className="opacity-40 hidden sm:inline">|</span>
            <Link to="/faqs" className="hover:text-sky-300">
              FAQs
            </Link>

            <span className="opacity-40 hidden sm:inline">|</span>
            <Link to="/disclaimer" className="hover:text-sky-300">
              Disclaimer
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default LocationFooter;